// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.service-title {
  font-family: "WMFT-SemiBold";
  font-size: 2rem;
  text-align: center;
  text-transform: uppercase;
}

.circle {
  width: 11rem;
  height: 11rem;
  border-radius: 50%;
}

.card-container {
  display: flex;
  width: 100%;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
  gap: 1rem;
}

#map {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 80vh;
  background-color: #d9d9d9;
}

.map-iframe {
  width: 60%;
}

.video-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-bottom: 56.25%;

  /* 16:9 */
  margin-top: -260px;
  width: 100%;
  pointer-events: none;
}

.video-text {
  font-size: 3rem;
  color: white;
  z-index: 2;
  position: relative;
  bottom: 160px;
  box-sizing: border-box;
  font-family: "WMFD-Bold";
  text-align: center;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%);
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.home-banner {
  position: absolute;
  top: -5rem;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

.home-section {
  display: flex;
  flex-direction: row;
  width: 60%;
  padding-bottom: 2rem;
  border-bottom: 1px solid lightgrey;
  gap: 2rem;
  margin-bottom: 2rem;
}

.home-row {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 2rem;
}

.image-home-container {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.reverse {
  flex-direction: row-reverse;
}

@media (max-width: 1200px) {
  .home-section {
    width: 80%;
  }
  .map-iframe {
    width: 80%;
  }
}

@media (max-width: 1000px) {
  .video-text {
    font-size: 2rem;
    bottom: 65px;
    height: 60px;
  }

  .home-container {
    transform: translateY(-10vh);
  }
}
@media (max-width: 768px) {
  .home-section {
    flex-direction: column;
    width: 90%;
  }
  .map-iframe {
    width: 90%;
  }
  .home-banner {
    width: 210%;
    left: -50%;
  }
  .video-wrapper {
    position: relative;
    /* padding-bottom: 56.25%; */
    /* 16:9 */
    margin-top: -150px;
    width: 100%;
    pointer-events: none;
    height: 40vh;
  }

  .service-title {
    font-size: 1.25rem;
  }
  .circle {
    width: 8rem;
    height: 8rem;
    border-radius: 50%;
  }
  .video-text {
    font-size: 1.5rem;
  }
}

@media (max-width: 550px) {
  .home-banner {
    width: 280%;
    left: -90%;
  }

  .video-text {
    font-size: 1rem;
  }
  .card-container {
    flex-direction: column;
    gap: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;EACP,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;;EAEtB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,+EAA+E;EAC/E,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF","sourcesContent":[".service-title {\r\n  font-family: \"WMFT-SemiBold\";\r\n  font-size: 2rem;\r\n  text-align: center;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.circle {\r\n  width: 11rem;\r\n  height: 11rem;\r\n  border-radius: 50%;\r\n}\r\n\r\n.card-container {\r\n  display: flex;\r\n  width: 100%;\r\n}\r\n\r\n.card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  flex: 1;\r\n  gap: 1rem;\r\n}\r\n\r\n#map {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  height: 80vh;\r\n  background-color: #d9d9d9;\r\n}\r\n\r\n.map-iframe {\r\n  width: 60%;\r\n}\r\n\r\n.video-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: relative;\r\n  padding-bottom: 56.25%;\r\n\r\n  /* 16:9 */\r\n  margin-top: -260px;\r\n  width: 100%;\r\n  pointer-events: none;\r\n}\r\n\r\n.video-text {\r\n  font-size: 3rem;\r\n  color: white;\r\n  z-index: 2;\r\n  position: relative;\r\n  bottom: 160px;\r\n  box-sizing: border-box;\r\n  font-family: \"WMFD-Bold\";\r\n  text-align: center;\r\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%);\r\n  height: 80px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n\r\n.home-banner {\r\n  position: absolute;\r\n  top: -5rem;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 1;\r\n  pointer-events: none;\r\n}\r\n\r\n.home-section {\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 60%;\r\n  padding-bottom: 2rem;\r\n  border-bottom: 1px solid lightgrey;\r\n  gap: 2rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.home-row {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  gap: 2rem;\r\n}\r\n\r\n.image-home-container {\r\n  display: flex;\r\n  height: 100%;\r\n  width: 100%;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.reverse {\r\n  flex-direction: row-reverse;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .home-section {\r\n    width: 80%;\r\n  }\r\n  .map-iframe {\r\n    width: 80%;\r\n  }\r\n}\r\n\r\n@media (max-width: 1000px) {\r\n  .video-text {\r\n    font-size: 2rem;\r\n    bottom: 65px;\r\n    height: 60px;\r\n  }\r\n\r\n  .home-container {\r\n    transform: translateY(-10vh);\r\n  }\r\n}\r\n@media (max-width: 768px) {\r\n  .home-section {\r\n    flex-direction: column;\r\n    width: 90%;\r\n  }\r\n  .map-iframe {\r\n    width: 90%;\r\n  }\r\n  .home-banner {\r\n    width: 210%;\r\n    left: -50%;\r\n  }\r\n  .video-wrapper {\r\n    position: relative;\r\n    /* padding-bottom: 56.25%; */\r\n    /* 16:9 */\r\n    margin-top: -150px;\r\n    width: 100%;\r\n    pointer-events: none;\r\n    height: 40vh;\r\n  }\r\n\r\n  .service-title {\r\n    font-size: 1.25rem;\r\n  }\r\n  .circle {\r\n    width: 8rem;\r\n    height: 8rem;\r\n    border-radius: 50%;\r\n  }\r\n  .video-text {\r\n    font-size: 1.5rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 550px) {\r\n  .home-banner {\r\n    width: 280%;\r\n    left: -90%;\r\n  }\r\n\r\n  .video-text {\r\n    font-size: 1rem;\r\n  }\r\n  .card-container {\r\n    flex-direction: column;\r\n    gap: 2rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
